<template>
  <AppView class="home" empty>
    <div class="home__header">
      <div class="home__logo">
        <img src="@/assets/logo.png" />
      </div>

      <div class="home__headline">
        <img :src="$t('app.contestLogo')" />
      </div>

      <ul class="home__menu">
        <li class="home__menu__item">
          <router-link to="/language" class="home__menu__link home__menu__link--icon">{{ $t('menu.language') }} <img :src="$t('menu.language.icon')" /></router-link>
        </li>

        <li class="home__menu__item">
          <router-link to="/gallery" class="home__menu__link">{{ $t('menu.gallery') }}</router-link>
        </li>

        <li class="home__menu__item home__menu__item--mobile-only">
          <a href="#" class="home__menu__link" v-scroll-to="'#prizes'">{{ $t('home.button.prizes') }}</a>
        </li>
      </ul>
    </div>

    <div class="home__content">
      <div class="home__column">
        <div>
          <div class="home__artwork">
            <img src="@/assets/home-artwork.png" />
            <img src="@/assets/home-pencil.png" />
          </div>

          <ul class="home__rules">
            <li>{{ $t('home.rules.1') }}</li>
            <li>{{ $t('home.rules.2') }}</li>
            <li>{{ $t('home.rules.3') }}</li>
            <li>{{ $t('home.rules.4') }}</li>
          </ul>
        </div>
      </div>

      <div class="home__column">
        <!-- <img src="@/assets/home-poster.png" class="home__poster" /> -->
        <div class="home__poster">
          <iframe width="560" height="315" :src="$t('home.youtube')" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>

        <div class="home__cta">
          <p>{{ $t('home.cta.text') }}</p>

          <img src="@/assets/home-cta-arrow.png" />

          <router-link to="/contest" class="home__button">{{ $t('home.cta.button') }}</router-link> 

          <!-- <router-link to="/winners" class="home__button">{{ $t('app.winners') }}</router-link> -->
        </div>

        <p class="home__schedule">{{ $t('home.schedule') }}</p>
      </div>

      <div class="home__column">
        <div>
          <div class="home__prizes" id="prizes">
            <img :src="$t('home.prizes')" />
          </div>

          <div class="home__spinmaster">
            <!--<img src="@/assets/spinmaster.png" />-->
          </div>
        </div>
      </div>
    </div>

    <p class="home__info" v-html="$t('home.info')"></p>
  </AppView>
</template>

<script>
import AppView from '@/components/AppView.vue';

export default {
  name: 'Home',
  components: {
    AppView,
  },
};
</script>

<style lang="scss">
.home {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 30px 0 0 85px;

    @media screen and (max-width: 1366px) {
      display: block;
      padding-left: 0;
    }
  }

  &__logo {
    img {
      display: block;
      width: 100%;
    }

    @media screen and (max-width: 1366px) {
      max-width: 300px;
      margin: 0 auto;
    }
  }

  &__headline {
    margin: 0 30px;

    img {
      width: 100%;
    }
  }

  &__menu {
    align-self: flex-start;

    @media screen and (max-width: 1366px) {
      margin: 50px 0;
    }

    &__item {
      padding: 25px 50px 25px 60px;

      background-color: #0e76bc;

      transform: skewX(-20deg);
      transform-origin: bottom left;

      @media screen and (max-width: 1366px) {
        transform: none;
      }

      &:not(:first-child) {
        margin-top: 15px;
      }

      &--mobile-only {
        display: none;
        @media screen and (max-width: 1366px) {
          display: block;
        }
      }
    }

    &__link {
      display: block;
      font-size: 26px;
      font-weight: bold;
      text-align: center;
      text-decoration: none;
      text-transform: uppercase;
      color: inherit;

      transform: skewX(20deg);
      transform-origin: bottom left;

      @media screen and (max-width: 1366px) {
        transform: none;
        text-align: left;
      }

      &--icon {
        position: relative;
        padding-right: 70px;

        img {
          position: absolute;
          right: 0;
          top: 50%;
          width: 50px;

          transform: translateY(-50%);
        }
      }

      &:hover {
        color: #ffff00;
      }
    }
  }

  &__content {
    display: flex;
    align-items: stretch;
    justify-content: center;

    margin-top: 20px;

    @media screen and (max-width: 1900px) {
      display: block;
    }
  }

  &__column {
    position: relative;
    min-height: 100px;

    @media screen and (max-width: 1900px) {
      max-width: 1024px;
      margin: 20px auto;
    }

    &:nth-child(1) {
      flex: 1 0 0;

      background-image: url('~@/assets/home-border-top-left.png'), url('~@/assets/home-border-bottom-left.png');
      background-position: left top, left bottom;
      background-repeat: no-repeat, no-repeat;
      background-size: auto 80px;

      @media screen and (max-width: 1900px) {
        background-image: none;
      }

      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        min-height: 100%;
        padding: 100px 40px 100px 32%;

        @media screen and (max-width: 1900px) {
          padding: 0;
        }
      }
    }

    &:nth-child(2) {
      flex: 0 0 850px;
      align-self: center;
    }

    &:nth-child(3) {
      flex: 1 0 0;

      background-image: url('~@/assets/home-border-top-right.png'), url('~@/assets/home-border-bottom-right.png');
      background-position: right top, right bottom;
      background-repeat: no-repeat, no-repeat;
      background-size: auto 80px;

      @media screen and (max-width: 1900px) {
        background-image: none;
        max-width: 500px;
      }

      & > div {
        padding: 100px 30px 100px 60px;

        @media screen and (max-width: 1900px) {
          padding: 50px 0;
        }

        @media screen and (max-width: 1366px) {
          padding: 0;
        }
      }
    }
  }

  &__poster {
    position: relative;
    display: block;
    width: 100%;
    padding-top: 56.25%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__cta {
    position: relative;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    justify-content: center;

    // margin-top: -3%;
    padding: 20px 40px;
    z-index: 1;

    background-color: #0e76bc;

    @media screen and (max-width: 960px) {
      display: block;
    }

    p {
      font-size: 23px;
      font-weight: bold;
      text-align: center;
      text-transform: uppercase;
      color: #ffff00;

      @media screen and (max-width: 960px) {
        font-size: 50px;
      }
    }

    img {
      margin: 0 20px 0 0;

      @media screen and (max-width: 960px) {
        display: none;
      }
    }
  }

  &__button {
    display: block;
    padding: 20px 30px;

    font-size: 32px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap;
    color: #0e76bc;

    background-color: #ffff00;

    @media screen and (max-width: 960px) {
      margin-top: 20px;
    }

    @media screen and (max-width: 600px) {
      font-size: 16px;
    }
  }

  &__prizes {
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__spinmaster {
    position: absolute;
    bottom: -50px;
    right: 0;
    max-width: 196px;

    @media screen and (max-width: 1900px) {
      position: relative;
      bottom: 0;
      margin: 30px auto;
    }

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }

  &__schedule {
    margin-top: 15px;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    color: #fefefe;
    text-shadow: rgb(0, 0, 0) 1px 0px 0px, rgb(0, 0, 0) 0.540302px 0.841471px 0px, rgb(0, 0, 0) -0.416147px 0.909297px 0px, rgb(0, 0, 0) -0.989992px 0.14112px 0px, rgb(0, 0, 0) -0.653644px -0.756802px 0px, rgb(0, 0, 0) 0.283662px -0.958924px 0px, rgb(0, 0, 0) 0.96017px -0.279415px 0px;
  }

  &__info {
    max-width: 440px;
    margin: 35px auto 0;

    font-size: 15px;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
    color: #ffffff;

    @media screen and (max-width: 1366px) {
      margin-top: 0;
    }

    a {
      color: inherit;

      &:hover {
        color: #ffff00;
      }
    }
  }

  &__artwork {
    position: absolute;
    top: 150px;
    left: 0;

    width: 32%;

    @media screen and (max-width: 1900px) {
      display: none;
    }

    img {
      &:nth-child(1) {
        display: block;
        width: 100%;
        height: auto;
      }

      &:nth-child(2) {
        position: absolute;
        top: 83px;
        right: 10px;
      }
    }
  }

  &__rules {
    padding-left: 10px;
    counter-reset: rules;

    @media screen and (max-width: 1900px) {
      padding-left: 0;
    }

    li {
      position: relative;
      counter-increment: rules;
      padding-left: 60px;

      font-size: 16px;
      line-height: 1.25em;
      font-weight: bold;
      letter-spacing: normal;
      text-transform: uppercase;
      color: #ffffff;

      @media screen and (max-width: 1900px) {
        padding: 20px 0 20px 60px;
      }

      &:not(:first-child) {
        margin-top: 20px;

        @media screen and (max-width: 1366px) {
          margin-top: 0;
        }
      }

      &::after {
        content: counter(rules);

        position: absolute;
        top: 0;
        left: 0;

        display: flex;
        align-items: center;
        justify-content: center;

        width: 44px;
        height: 44px;
        background-color: #ffffff;
        border-radius: 50%;

        font-size: 30px;
        color: #0e76bc;

        @media screen and (max-width: 1900px) {
          top: 50%;
          transform: translateY(-50%);
        }
      }

      &:last-child {
        color: #ffff00;

        &::after {
          background-color: #ffff00;
        }
      }
    }
  }
}
</style>
